<template>
  <div class="form">
    <div v-if="loading" class="loading">
      <Loader />
    </div>
    <div v-else>
      <div class="header">
        <img id="logo" v-if="isLogoAvailable && logoPath" :src="logoPath" :alt="'logo-demo'">
      </div>
      <div v-if="appConfigurationStore.appConfiguration" class="form-container">
        <FormGenerator :form-model="tokenStore.payload.formModel" :form-action="tokenStore.payload.formAction"
          buttonContent="create" @form-data="sendForm" />
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'
import { configurationService } from '@/services/configuration.service'
import { appConfigurationStore } from '@/stores/appConfigurationStore.js'
import { tokenStore } from '@/stores/tokenStore.js'
import { getPartnerLogo } from '@/utils.js'
import { customerService } from '@/services/customer.service'
import FormGenerator from '@/components/GenericComponents/FormGenerator.vue'

export default {
  name: 'FormPage',
  components: {
    FormGenerator,
    Loader
  },
  data() {
    return {
      loading: true,
      partnerLogoUrl: null,
      formModel: null,
      formAction: null,
      appConfigurationStore: appConfigurationStore(),
      tokenStore: tokenStore()
    }
  },
  computed: {
    isLogoAvailable() {
      if (this.tokenStore.payload.partner != null && this.tokenStore.payload.partner != '') {
        this.setLogoPath(this.tokenStore.payload.partner)
        return true
      } else {
        return false
      }
    }
  },
  async mounted() {
    if (this.tokenStore.currentToken) {
      this.formModel = this.tokenStore.payload.formModel
      this.formAction = this.tokenStore.payload.formAction
      const formConfig = await configurationService.getFormConfiguration(
        this.formModel,
        this.formAction
      )
      if (formConfig == null) {
        this.$router.push({
          name: 'ErrorPage',
          query: {
            errorMsg: 'tokenRevoked',
            errorText: 'forbidden',
            errorCode: '403'
          },
          params: { pathMatch: 'errorToken' }
        })
      } else {
        appConfigurationStore().appConfiguration = { parameters: { [this.formModel]: { [this.formAction]: formConfig } } }
        this.loading = false
      }
    } else {
      this.$router.push({
        name: 'ErrorPage',
        query: {
          errorMsg: 'errorOccured',
          errorText: 'unauthorized',
          errorCode: '401'
        },
        params: { pathMatch: 'errorToken' }
      })
    }
  },
  methods: {
    async sendForm(formData) {
      this.loading = true
      if (
        formData &&
        this.formModel == 'customers' &&
        this.formAction.includes('create')
      ) {
        let customer = await customerService.createCustomer(
          null,
          JSON.parse(JSON.stringify(formData))
        )
        if (customer.id_customer) {
          this.$router.push({ name: 'ThankYouPage' })
        } else {
          this.$router.push({
            name: 'ErrorPage',
            query: {
              statusCode: '500',
              errorMsg:
                'An error occured while creating your client account.'
            },
            params: { pathMatch: 'errorCreate' }
          })
        }
      }
      this.loading = false
    },
    setLogoPath() {
      this.logoPath = getPartnerLogo(this.tokenStore.payload.partner)
    }
  }
}
</script>

<style scoped>
.header {
  position: relative;
  height: 130px;
  overflow: hidden;
}

#logo {
  max-width: 300px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 0;
  left: 0;
}
</style>
